@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/typography/typography' as *;

@keyframes flyToNavigation {
  95% {
    opacity: 1;
  }

  100% {
    opacity: 0;
    transform: translate(
        var(--dismiss-translate-x),
        var(--dismiss-translate-y)
      )
      scale(var(--dismiss-scale));
  }
}

@keyframes fadeAndSlide {
  to {
    opacity: 0;
    transform: translateY(8px);
  }
}

.root {
  display: flex;
  flex-direction: column;
  width: 302px;
  padding: 16px;
  margin: 0 0 16px auto;
  background: linear-gradient(
    180deg,
    rgba(var(--background-default-rgb), 0) 0%,
    rgba(var(--background-default-rgb), 1) 100%
  );
  cursor: pointer;
  transform-origin: center;
}

.card {
  @include border-radius-r2;
  display: flex;
  position: relative;
  width: 100%;
  height: 44px;
  align-items: center;
  gap: 8px;
  padding: 12px;
  overflow: hidden;
  border: 1px solid var(--border-default);
  color: var(--text-default);
  background: rgba(var(--background-default-rgb), 0.8);
  cursor: pointer;
  text-align: left;

  &:hover {
    background: rgba(var(--background-default-rgb), 0.9);
  }

  svg {
    flex-shrink: 0;
    cursor: pointer;
    pointer-events: none;
  }
}

.cardText {
  @include typography-v2-body-sm;
  flex: 1;
  min-width: 0;
  cursor: pointer;
  pointer-events: none;
}

.progressBar {
  animation-fill-mode: forwards, none;
  animation-iteration-count: 1, infinite;
}

.flyDismissal,
.fallbackDismissal {
  pointer-events: none;
  will-change: opacity, transform;
}

.flyDismissal {
  animation: flyToNavigation 500ms ease-in forwards;
}

.fallbackDismissal {
  animation: fadeAndSlide 200ms ease-in forwards;
}

@media (prefers-reduced-motion: reduce) {
  .progressBar {
    width: 100%;
    animation: none;
  }
}
